import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ClockIcon } from '../../assets';
import { theme } from '../../theme';
import { BodyText, Heading } from '../typography';
import { ProgressSize } from './Progress';
import { ProgressContainer } from './ProgressContainer';
import {
  ProgressHeader,
  SubHeading,
  SubHeadingPrimary,
  SubHeadingSecondary,
} from './ProgressHeader';
import { ProgressSteps } from './ProgressSteps';
import { StyledProgressBar } from './StyledProgressBar';

const StyledNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  margin-top: ${theme.spacings[5].rem};
`;

const ProgressPadding = styled.div`
  display: flex;
  padding: 0 ${theme.spacings[3].rem};
`;

export type ProgressBarProps = PropsWithChildren<{
  currentStep: number;
  size: ProgressSize;
  heading: string;
  subHeading: string;
  subHeadingTimingText?: string;
  stepCount: number;
}>;

export const ProgressBar: React.FC<ProgressBarProps> = ({
  children,
  currentStep,
  stepCount,
  heading,
  size,
  subHeading,
  subHeadingTimingText,
}) => {
  return (
    <ProgressContainer size={size}>
      <ProgressHeader size={size}>
        <Heading size={3}>{heading}</Heading>
        <SubHeading>
          <SubHeadingPrimary size="lg" progressSize={size}>
            {subHeading}
          </SubHeadingPrimary>
          {subHeadingTimingText && (
            <SubHeadingSecondary progressSize={size}>
              <ClockIcon width={16} height={16} />{' '}
              <BodyText>{subHeadingTimingText}</BodyText>
            </SubHeadingSecondary>
          )}
        </SubHeading>
      </ProgressHeader>
      <StyledNav>
        <ProgressPadding>
          <StyledProgressBar
            /* value & max are scaled back for 0-based index progress bar */
            value={currentStep - 1}
            max={stepCount - 1}
          ></StyledProgressBar>
        </ProgressPadding>
        <ProgressSteps>{children}</ProgressSteps>
      </StyledNav>
    </ProgressContainer>
  );
};
